// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ContainerIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ContainerIcon" ref={forwardedRef} {...props}>
      <path d="M9.345 1.437a1 1 0 0 1 .993-.01l6.9 3.859a1 1 0 0 1 .512.873v7.707a1 1 0 0 1-.512.872l-6.9 3.86a1 1 0 0 1-.993-.01l-6.6-3.856A1 1 0 0 1 2.25 13.87V6.156a1 1 0 0 1 .496-.864zm.51 1.439L4.487 6.012l5.368 3.136 5.608-3.136zm6.395 4.415-5.653 3.161v6.281l5.653-3.16zm-7.153 9.415v-6.263L3.75 7.319v6.263z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ContainerIcon = /* @__PURE__ */ Object.assign(
  ContainerIconComponent,
  { displayName: 'ContainerIcon' },
);
